import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContestReplyChildComment } from "../../../../../../redux/contest/action";
import getTimeDifference from "../../../../../Common/TimeDifference";

export default function ChildCommentListing({ item }) {
  const dispatch = useDispatch();
  const gcpcl = useSelector(
    ({ contest: { getcontestpublicchildcommentlist } }) =>
      getcontestpublicchildcommentlist,
  );

  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(5);

  useEffect(() => {
    if (item.id !== null) {
      setLoading(true);
      dispatch(getContestReplyChildComment(item.id, size)).finally(() =>
        setLoading(false),
      );
    }
  }, [dispatch, item?.id, size]);

  const handleLoadMore = () => {
    setSize((prevSize) => prevSize + 5);
  };
  return (
    <div>
      {Array.isArray(gcpcl?.response) &&
        gcpcl?.response.map((item1, index) => (
          <div className="comment-sec1" key={index}>
            <div className="comment-sec">
              <img
                style={{ width: 40, height: 40 }}
                src={item1?.profile_image}
                alt=""
              />
              <div>
                <div className="profile-sec">
                  <h6>
                    {item1?.first_name} {item1?.last_name}
                  </h6>
                  <p>{getTimeDifference(item1?.created_on)}</p>
                </div>
                <p>{item1?.message}</p>
              </div>
            </div>
          </div>
        ))}

      {gcpcl?.count > gcpcl?.response?.length && (
        <button className="btn" onClick={handleLoadMore} disabled={loading}>
          {loading ? "Loading..." : "View More Comments"}
        </button>
      )}
    </div>
  );
}
